import { render, staticRenderFns } from "./DemoCard.vue?vue&type=template&id=7812d696"
import script from "./DemoCard.vue?vue&type=script&lang=js"
export * from "./DemoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports